import {
    RETRIEVE_SOURCES,
    CREATE_SOURCE,
    UPDATE_SOURCE,
    DELETE_SOURCE,
    RESTORE_SOURCE,
} from "../actions/types";
  
  const initialState = { sources : [], totalSourceCount : 0 };

const sourceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_SOURCES:
      return {
        sources: payload.rows,
        totalSourceCount: payload.count,
      };

    case CREATE_SOURCE:
      return payload;

    case UPDATE_SOURCE:
      return payload;

    case DELETE_SOURCE:
      return {
        sources: payload.rows,
        totalSourceCount: payload.count,
      };

    case RESTORE_SOURCE:
      return {
        sources: payload.rows,
        totalSourceCount: payload.count,
      };

    default:
      return state;
  }
};

export default sourceReducer;